import styled, {css} from 'styled-components';

interface ItemProps {
  readonly lColor?: string;
  readonly rColor?: string;
  readonly fColor?: string;
  readonly bColor?: string;
  readonly lMargin?: string;
  readonly rMargin?: string;
  readonly xMargin?: string;
  fullWidth?: boolean;
}
export const ButtonContainer = styled.div<ItemProps>`
  align-items: center;
  border-radius: 10px;
  cursor: pointer;
  display: inline-flex;
  height: 30px;

  ${props => {
    const bColor = `border: 1px solid ${props.bColor};`;
    const xMargin = `margin: ${props.xMargin};`;

    return css`
      {
        ${bColor}
        ${xMargin}
      }
    `;
  }}
`;

export const ButtonIcon = styled.span<ItemProps>`
  border-bottom-left-radius: 10px;
  color: var(--BackgroundColor);
  border-top-left-radius: 10px;
  display: inline-flex;
  align-items: center;
  height: 100%;

  ${props => {
    let lColor = '';
    const lMargin = `padding: ${props.lMargin};`;
    if (props.lColor) {
      lColor = `background-color: ${props.lColor};`;
    } else {
      lColor = `background-color: var(--SecondaryBlue);`;
    }

    return css`
        ${lColor}
        ${lMargin}
    `;
  }}
`;

export const ButtonSpan = styled.span<ItemProps>`
  border-bottom-right-radius: 10px;
  color: var(--BackgroundColor);
  border-top-right-radius: 10px;
  display: inline-flex;
  align-items: center;
  width: ${props => (props.fullWidth ? '100%' : 'max-content')};
  font-weight: 550;
  font-size:12px !important;
  height: 100%;
  justify-content: center;
  ${props => {
    let rColor = '';
    let cursor = `cursor:pointer`;
    const rMargin = `padding: 0 20px;`;
    const fColor = `color: ${props.fColor};`;

    if (props.rColor) {
      rColor = `background-color: ${props.rColor};`;
    } else {
      rColor = `background-color: var(--PrimaryBlue);`;
    }
    if(props.rColor==='#ACB1C0'){
     cursor =`cursor:default`;
    }


    return css`
        ${rColor}
        ${fColor}
        ${rMargin}
        ${cursor}
    `;
  }}
`;
